import * as React from 'react'

const SvgFilmIcon = ({ stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="37"
    fill="none"
    viewBox="0 0 36 37"
  >
    <rect width="32" height="32" x="2" y="2.88" fill="#E0EAFF" rx="16"></rect>
    <path
      stroke="#444CE7"
      d="M18 25.546V12.213m-3.333 13.333v-3.333m0-6.667v-3.333m6.666 13.333v-3.333m0-6.667v-3.333m-10 3.333h13.334m-13.334 6.667h13.334m0 .133v-6.933c0-1.12 0-1.68-.218-2.108a2 2 0 00-.874-.874c-.428-.218-.988-.218-2.108-.218h-6.934c-1.12 0-1.68 0-2.108.218a2 2 0 00-.874.874c-.218.428-.218.988-.218 2.108v6.933c0 1.12 0 1.68.218 2.108a2 2 0 00.874.874c.428.218.988.218 2.108.218h6.934c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874c.218-.428.218-.988.218-2.108z"
    ></path>
    <rect width="32" height="32" x="2" y="2.88" stroke="#EEF4FF" rx="16"></rect>
    <defs>
      <clipPath id="clip0_7503_57223">
        <path
          fill="#fff"
          d="M0 0H16V16H0z"
          transform="translate(10 10.88)"
        ></path>
      </clipPath>
    </defs>
  </svg>
)

export default SvgFilmIcon
